var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Mostrar solo de tipo : ")]),_vm._l((_vm.data),function(ref){
var id = ref.id;
var nivel = ref.nivel;
return _c('b-button',{key:id,staticClass:"mr-75",attrs:{"variant":_vm.selected === id ? 'secondary' : 'primary',"size":"sm"},on:{"click":function () { return _vm.handleClick(id); }}},[(_vm.selected === id)?_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":"CheckIcon"}}):_vm._e(),_vm._v(" "+_vm._s(nivel)+" ")],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }